import styled from 'styled-components';

/*export const Container = styled.div`
  img {
    width: 100%;
  }
`;*/

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 60%;
  }

  @media (max-width: 720px) {
    img {
      width: 100%;
    }
  }
`;

export const ContaineText = styled.div`
  margin: 0 auto;
  p {
    font-family: 'Inter', sans-serif;
    color: #0000c9;
    font-weight: 500;
    font-size: 58px;
    line-height: 80px;
  }
`;
